export enum priceType {
  PURCHASE = 'PURCHASE',
  SALES = 'SALES',
  TIME = 'TIME',
};



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price.enum.ts